<template>
  <b-row class="block__profile-notifications" >

    <!-- ENTETE -->
    <div class="mobile">
      <div class="link">
        <button class="bt btn-back"  v-b-toggle.sidebar-4>
            <font-awesome-icon :icon="['far', 'angle-left']"/>
        </button>
        <h3>{{general.profileTitleNotifications}}</h3>
      </div>
      <div class="sep"></div> 
    </div>
    <!-- ENTETE -->

    <!-- CONTENT -->
    <div class="scrollable col">
      <b-list-group>
        <b-list-group-item>
          <PuSkeleton :loading="isLoading" :count="1" width='100%' height='2rem'>    
              {{items[0].name}}
              <div class="wrapper-button">
                <ion-toggle :checked="notif.maj_chiffre"  @ionChange="updated($event.currentTarget.value)" value="NOTIF_MAJ_CHIFFRE"></ion-toggle>
              </div>
          </PuSkeleton>
        </b-list-group-item>

        <b-list-group-item>
          <PuSkeleton :loading="isLoading" :count="1" width='100%' height='2rem'>    
              {{items[1].name}}
              <div class="wrapper-button">
                <ion-toggle :checked="notif.objectif"   @ionChange="updated($event.target.value)" value="NOTIF_OBJECTIF"></ion-toggle>
              </div>
          </PuSkeleton>
        </b-list-group-item>

        <b-list-group-item>
          <PuSkeleton :loading="isLoading" :count="1" width='100%' height='2rem'>    
              {{items[2].name}}
              <div class="wrapper-button">
                <ion-toggle :checked="notif.chiffre" @ionChange="updated($event.target.value)" value="NOTIF_CHIFFRE"></ion-toggle>
              </div>
          </PuSkeleton>
        </b-list-group-item>

        <b-list-group-item>
          <PuSkeleton :loading="isLoading" :count="1" width='100%' height='2rem'>    
              {{items[3].name}}
              <div class="wrapper-button">
                <ion-toggle :checked="notif.challenge" @ionChange="updated($event.target.value)" value="NOTIF_CHALLENGE"></ion-toggle>
              </div>
          </PuSkeleton>
        </b-list-group-item>
        
        <b-list-group-item>
          <PuSkeleton :loading="isLoading" :count="1" width='100%' height='2rem'>    
              {{items[4].name}}
              <div class="wrapper-button">
                <ion-toggle :checked="notif.concours" @ionChange="updated($event.target.value)" value="NOTIF_CONCOURS"> </ion-toggle>
              </div>
          </PuSkeleton>
        </b-list-group-item>

        <b-list-group-item>
          <PuSkeleton :loading="isLoading" :count="1" width='100%' height='2rem'>    
              {{items[5].name}}
              <div class="wrapper-button">
                <ion-toggle :checked="notif.maj_concours" @ionChange="updated($event.target.value)" value="NOTIF_MAJ_CONCOURS"></ion-toggle>
              </div>
          </PuSkeleton>
        </b-list-group-item>
      </b-list-group> 



    </div>
    <!-- CONTENT -->


  </b-row>
</template>




<script>
import { mapGetters } from 'vuex'
import ApiService from '../../../../services/ApiService'
//import ApiAuthenticationService from '../../../../services/ApiAuthenticationService'

export default {
  name:"ProfileNotifications",
    components:{
    }, 
    computed: {
      ...mapGetters([
        'getGeneral',
        'getInitial'
      ])
    },
    data () {
      return {
        general:"",
        isLoading:true,
        items:[],
        infos:null,
        notif:{
            challenge:true,
            chiffre:true,
            consours: true,
            maj_chiffre:true,
            maj_concours:true,
            objectif:true

        }
      }
    },
    created (){
      //PASS ALL THE GENERAL TRANSLATE
      this.general = this.getGeneral;
      this.items = this.general.profileNotifications;
      //
      this.getData();      
    },    
    methods : {
      async getData(){
        //GET THE DATA
        this.isLoading  = true;
        //
        await ApiService.getProfilApi().get().then((data) => {
          this.infos = data.data
          this.infos = this.infos.notificationTypes;
          //
          //PASS PARAMS TO VARIABLES
          this.notif.challenge = this.infos.NOTIF_CHALLENGE;
          this.notif.chiffre = this.infos.NOTIF_CHIFFRE;
          this.notif.concours = this.infos.NOTIF_CONCOURS;
          this.notif.maj_chiffre = this.infos.NOTIF_MAJ_CHIFFRE;
          this.notif.maj_concours = this.infos.NOTIF_MAJ_CONCOURS;
          this.notif.objectif = this.infos.NOTIF_OBJECTIF;
          this.isLoading  = false;
        });
      },
      async updated($event){
        //WHEN TOGGLE A NOTIFICATION
        let updated = await ApiService.getProfilApi().modifyNotif($event);
        //IF SUCCESS OR ERROR
        updated.status != '200' ?  this.messageError() : '';
      },

      messageError(){
        // this.makeToast('error')
      },  

      //AFFICHAGE DU TOAST
      makeToast(variant = null) {
        if(variant == 'success'){
          this.$bvToast.toast(this.general.messagerieSuccess, {
            title: this.general.messagerieToastTitle,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          })  
        } else if(variant == 'error'){
          this.$bvToast.toast(this.general.messagerieError, {
            title: this.general.messagerieToastTitle,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          }) 
        }
      },

      //GO BACK
      goBack() {
        this.$router.push({name: "profileHome"});  
      },       
    }
};
</script>
